(() => {
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => [...r.querySelectorAll(s)];
  const focusableSelector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const header = q('[data-header]');
  let activeOverlay = null;
  let lastFocused = null;

  const onScroll = () => header && header.classList.toggle('is-scrolled', window.scrollY > 16);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const lockPage = () => document.body.classList.add('mm-overlay-open');
  const unlockPage = () => document.body.classList.remove('mm-overlay-open');
  const rememberFocus = () => { lastFocused = document.activeElement; };
  const restoreFocus = () => { if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus(); lastFocused = null; };

  function focusFirst(container) {
    requestAnimationFrame(() => {
      const target = q(focusableSelector, container) || container;
      target?.focus?.();
    });
  }

  function trapFocus(e, container) {
    if (e.key !== 'Tab' || !container || container.hidden) return;
    const items = qa(focusableSelector, container).filter(el => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  const menu = q('[data-mobile-menu]');
  const menuPanel = q('[data-menu-panel]');
  const menuToggle = q('[data-menu-toggle]');
  const openMenu = () => {
    if (!menu) return;
    rememberFocus();
    menu.hidden = false;
    menu.setAttribute('aria-hidden', 'false');
    menuToggle?.setAttribute('aria-expanded', 'true');
    menuToggle?.setAttribute('aria-label', 'Close menu');
    activeOverlay = 'menu';
    lockPage();
    focusFirst(menuPanel || menu);
  };
  const closeMenu = (restore = true) => {
    if (!menu || menu.hidden) return;
    menu.hidden = true;
    menu.setAttribute('aria-hidden', 'true');
    menuToggle?.setAttribute('aria-expanded', 'false');
    menuToggle?.setAttribute('aria-label', 'Open menu');
    if (activeOverlay === 'menu') activeOverlay = null;
    unlockPage();
    if (restore) restoreFocus();
  };
  menuToggle?.addEventListener('click', () => menu?.hidden ? openMenu() : closeMenu());
  qa('[data-menu-close]').forEach(btn => btn.addEventListener('click', () => closeMenu()));
  qa('.mm-menu-links a').forEach(link => link.addEventListener('click', () => closeMenu(false)));

  const search = q('[data-search-overlay]');
  const openSearch = () => {
    if (!search) return;
    closeMenu(false);
    rememberFocus();
    search.hidden = false;
    search.setAttribute('aria-hidden', 'false');
    activeOverlay = 'search';
    lockPage();
    focusFirst(search);
  };
  const closeSearch = () => {
    if (!search || search.hidden) return;
    search.hidden = true;
    search.setAttribute('aria-hidden', 'true');
    if (activeOverlay === 'search') activeOverlay = null;
    unlockPage();
    restoreFocus();
  };
  qa('[data-search-toggle]').forEach(b => b.addEventListener('click', openSearch));
  q('[data-search-close]')?.addEventListener('click', closeSearch);

  const drawer = q('[data-cart-drawer]');
  const openCart = () => {
    if (!drawer) return;
    rememberFocus();
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    activeOverlay = 'cart';
    lockPage();
    focusFirst(drawer);
  };
  const closeCart = () => {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    if (activeOverlay === 'cart') activeOverlay = null;
    unlockPage();
    restoreFocus();
  };
  qa('[data-cart-open]').forEach(b => b.addEventListener('click', openCart));
  qa('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      if (activeOverlay === 'menu') closeMenu();
      else if (activeOverlay === 'search') closeSearch();
      else if (activeOverlay === 'cart') closeCart();
      return;
    }
    if (activeOverlay === 'menu') trapFocus(e, menu);
    else if (activeOverlay === 'search') trapFocus(e, search);
    else if (activeOverlay === 'cart') trapFocus(e, drawer);
  });

  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'GBP'
  }).format(cents / 100);

  async function fetchCart() {
    const res = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
    return res.json();
  }

  function make(tag, text, className) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined && text !== null) el.textContent = text;
    return el;
  }

  async function renderCart() {
    const cart = await fetchCart();
    qa('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const body = q('[data-cart-body]');
    const total = q('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
    if (!body) return;
    body.replaceChildren();
    if (!cart.items.length) {
      body.append(make('p', 'Your bag is empty.', 'muted'));
      return;
    }
    cart.items.forEach((item, i) => {
      const line = make('div', null, 'cart-line');
      const imageLink = make('a'); imageLink.href = item.url;
      if (item.image) { const img = document.createElement('img'); img.src = item.image; img.alt = item.product_title || ''; imageLink.append(img); }
      const details = make('div');
      const title = make('a', item.product_title); title.href = item.url; details.append(title);
      if (item.variant_title) details.append(make('small', item.variant_title));
      const controls = make('div', null, 'cart-line__controls');
      const minus = make('button', '−'); minus.type = 'button'; minus.dataset.cartChange = ''; minus.dataset.line = i + 1; minus.dataset.quantity = Math.max(0, item.quantity - 1); minus.setAttribute('aria-label', `Decrease ${item.product_title} quantity`);
      const qty = make('span', String(item.quantity));
      const plus = make('button', '+'); plus.type = 'button'; plus.dataset.cartChange = ''; plus.dataset.line = i + 1; plus.dataset.quantity = item.quantity + 1; plus.setAttribute('aria-label', `Increase ${item.product_title} quantity`);
      controls.append(minus, qty, plus); details.append(controls);
      line.append(imageLink, details, make('span', money(item.final_line_price)));
      body.append(line);
    });
  }

  // Safari and other browsers can restore an older page snapshot when navigating back.
  // Always re-sync the visible bag with Shopify's real cart whenever the page is shown again.
  window.addEventListener('pageshow', () => {
    renderCart().catch(() => {});
  });

  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    btn.disabled = true;
    await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(btn.dataset.line), quantity: Number(btn.dataset.quantity) })
    });
    await renderCart();
  });

  const productRoot = q('[data-product-root]');
  if (productRoot) {
    const variants = JSON.parse(q('[data-product-json]', productRoot)?.textContent || '[]');
    const select = q('[data-variant-select]', productRoot);
    const form = q('[data-product-form]', productRoot);
    const price = q('[data-product-price]', productRoot);
    const add = q('[data-add-button]', productRoot);
    const galleryItems = qa('[data-product-media]', productRoot);
    const syncGallery = variant => {
      if (!productRoot.hasAttribute('data-multi-colour') || !galleryItems.length) return;
      const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;
      let found = false;
      galleryItems.forEach(item => {
        const show = mediaId && String(item.dataset.mediaId) === String(mediaId);
        item.hidden = !show;
        if (show) found = true;
      });
      if (!found) galleryItems.forEach((item, index) => { item.hidden = index !== 0; });
    };
    const syncVariant = (syncMedia = true) => {
      const selectedValues = qa('.variant-fieldset', productRoot).map(fieldset => q('input[type="radio"]:checked', fieldset)?.value);
      const variant = variants.find(v => v.options.every((val, idx) => selectedValues[idx] === val));
      if (!variant || !select) return;
      select.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (add) { add.disabled = !variant.available; add.textContent = variant.available ? 'ADD TO BAG +' : 'SOLD OUT'; }
      if (syncMedia) syncGallery(variant);
    };
    qa('input[name^="options"]', productRoot).forEach(i => i.addEventListener('change', () => syncVariant(true)));
    syncVariant(false);
    form?.addEventListener('submit', async e => {
      e.preventDefault();
      if (add) add.disabled = true;
      const fd = new FormData(form);
      const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      if (res.ok) { await renderCart(); openCart(); }
      else if (add) add.textContent = 'Try again';
      if (add) add.disabled = false;
    });
  }
})();